import { render, staticRenderFns } from "./CouponView.vue?vue&type=template&id=bf294e50&scoped=true"
import script from "./CouponView.vue?vue&type=script&lang=js"
export * from "./CouponView.vue?vue&type=script&lang=js"
import style0 from "./CouponView.vue?vue&type=style&index=0&id=bf294e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf294e50",
  null
  
)

export default component.exports